import * as React from 'react';

import ListProductsDefault from './Layouts/ListProductsDefault';
import ListProductsTabbed from './Layouts/ListProductsTabbed';
import ListProductsScrollable from './Layouts/ListProductsScrollable';
import ListProductsGrid from './Layouts/ListProductsGrid';

import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';
import './ListProducts.scss';

const layouts = {
  'list-tabbed': ListProductsTabbed,
  'list-default': ListProductsDefault,
  'list-scrollable': ListProductsScrollable,
  'list-grid': ListProductsGrid
};

export const ListProducts = (props) => {
  const isMobile = useMobileBreakpoint(props.settings.mobile_breakpoint);
  // const LayoutComponent = layouts[props.settings?.section.layout_type] || ListProductsDefault;

  const LayoutComponent = isMobile
    ? layouts?.[props.settings?.section.layout_type_mobile] || layouts['list-default']
    : layouts?.[props.settings?.section.layout_type] || layouts['list-default'];

  return <LayoutComponent {...props} />;
};
